<template>
	<div class="main-view" id="main-h">

		<div class="dv-grid-view">
			<div class="dv-g-v-item" v-for="(item,key) in deviceList" ref="videob">
				<div class="dv-g-v-i-view" @dblclick="dblBtnClick">
					<div :id="item.id"></div>
				</div>
			</div>

		</div>
		<el-drawer title="产品目录" :visible.sync="drawer" :with-header="true" :direction="direction" :show-close="false"
			:size="switchSize">
			<el-tree :data="regionList" @node-click="handleNodeClick"></el-tree>
		</el-drawer>
	<!-- 	<el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
			点我打开
		</el-button> -->
		<img src="../../public/img/youbian.png" id="youbian" @click="drawer = true">
	</div>



</template>

<script>
	import EZUIKit from 'ezuikit-js';
	export default {
		name: "DeviceVideo",
		components: {

		},
		data() {
			return {
				switchSize: 180,
				direction: 'ltr',
				drawer: false,
				deviceList: [],
				tingZiList: [],
				playerList: [],
				regionList: [ {
					"label": "前往后台",
					"id": "4"
				}, {
					"label": "前往大数据",
					"id": "5"
				}],
				upVideo: -1,
				startD: 0
			}
		},
		methods: {
			videoClick(item) {
				let that = this;
				let v = this.$refs.videob[item];

				let vH = v.offsetHeight;
				let vW = v.offsetWidth;

				let i = this.deviceList[item];
				let id = i.id + "";
				var player = new EZUIKit.EZUIKitPlayer({
					id: id, // 视频容器ID
					accessToken: i.token,
					url: i.url,
					width: vW,
					height: vH,
					plugin: ["talk"],
					themeData: {
						"autoFocus": 5,
						"poster": "https://resource.eziot.com/group1/M00/00/89/CtwQEmLl8r-AZU7wAAETKlvgerU237.png",
						"header": {
							"color": "#1890ff",
							"activeColor": "#FFFFFF",
							"backgroundColor": "#000000",
							"btnList": [{
									"iconId": "deviceID",
									"part": "left",
									"defaultActive": 0,
									"memo": "顶部设备名称",
									"isrender": 1
								},
								{
									"iconId": "deviceName",
									"part": "left",
									"defaultActive": 0,
									"memo": "顶部设备ID",
									"isrender": 1
								},
								{
									"iconId": "cloudRec",
									"part": "right",
									"defaultActive": 0,
									"memo": "头部云存储回放",
									"isrender": 0
								},
								{
									"iconId": "rec",
									"part": "right",
									"defaultActive": 0,
									"memo": "头部本地回放",
									"isrender": 0
								}
							]
						},
						"footer": {
							"color": "#FFFFFF",
							"activeColor": "#1890FF",
							"backgroundColor": "#00000021",
							"btnList": [{
									"iconId": "play",
									"part": "left",
									"defaultActive": 1,
									"memo": "播放",
									"isrender": 1
								},
								{
									"iconId": "capturePicture",
									"part": "left",
									"defaultActive": 0,
									"memo": "截屏按钮",
									"isrender": 1
								},
								{
									"iconId": "sound",
									"part": "left",
									"defaultActive": 0,
									"memo": "声音按钮",
									"isrender": 1
								},
								{
									"iconId": "pantile",
									"part": "left",
									"defaultActive": 0,
									"memo": "云台控制按钮",
									"isrender": 1
								},
								{
									"iconId": "recordvideo",
									"part": "left",
									"defaultActive": 0,
									"memo": "录制按钮",
									"isrender": 1
								},
								{
									"iconId": "talk",
									"part": "left",
									"defaultActive": 0,
									"memo": "对讲按钮",
									"isrender": 1
								},
								{
									"iconId": "zoom",
									"part": "left",
									"defaultActive": 0,
									"memo": "电子放大",
									"isrender": 1
								},
								{
									"iconId": "hd",
									"part": "right",
									"defaultActive": 0,
									"memo": "清晰度切换按钮",
									"isrender": 1
								},
								{
									"iconId": "webExpend",
									"part": "right",
									"defaultActive": 0,
									"memo": "网页全屏按钮",
									"isrender": 1
								},
								{
									"iconId": "expend",
									"part": "right",
									"defaultActive": 0,
									"memo": "全局全屏按钮",
									"isrender": 1
								}
							]
						}
					}
				})


			},
			dblBtnClick() {
				this.player.fullScreen()
			},
			handleNodeClick(data) {
				if (data.id == "4") {

					window.location.href = "http://test.xiaozhuep.com/#/home"
				} else if (data.id == "5") {
					window.location.href = "http://a.xiaozhuep.com/index66.html"
				} else {
					let s = {};
					s.id = data.id;
					this.$router.push({
						path: '/deviceVideo',
						query: s
					});
					if (location.href.indexOf("#reloaded") == -1) {
						location.href = location.href;
						location.reload();
					}
				}
			}
		},
		mounted() {
			var query = this.$route.query;
			let id = query.id;
			console.log(id);
			if (id == undefined) {
				id = 1;
			}
			let that = this;
			this.$axios({
				method: 'post',
				url: '/camer/getList',
				data: {
					quality: "1"
				}
			}).then(function(respose) {
				if (respose.code == '1') {
					let content = respose.content;
					that.deviceList = content;
					that.$nextTick(function() {
						// console.log("bbbbbbbbbbbbbb");
						for (let i = 0; i < that.deviceList.length; i++) {
							that.videoClick(i);
						}
					})
				}
				console.log(respose);
			});


		}
	}
</script>

<style>
</style>
